import React from "react";
import i18next from "../localization/i18n";
import CallIcon from "@mui/icons-material/Call";
import SaitRowAction from "./SaitRowAction";

/*
	Obbligatori:
		id
		onClick
	Facoltativi:
*/

export default function SaitRowActionCall(config) {
	return SaitRowAction({
		id: config.id,
		icon: <CallIcon color="primary" />,
		tooltip: i18next.t("call_client"),
		objmod: config.objmod,
		onClick: (params) => {
			window.open("tel:" + config.phoneNumber(params));
		},
		conditionalRendering: (params) => {
			return config.phoneNumber(params);
		},
		roleSecurity: config.roleSecurity,
		hidden: config.hidden,
	});
}
